import React from "react";
import track from "react-tracking";
const Unsubscribe = () => (<div className="wrapper wrapper_narrow">
		<div className="vr vr_x5">
			<div className="text">
				<h2 style={{ fontWeight: "bold" }}>Thank You</h2>
				<br />
				Your email preference has been updated. We will not send further email communications
				to you unless you re-authorize us to email you.
				<br /><br />
				Please note, DCMS reserves the right to reply to you at the email provided for the
				limited purpose of providing assistance with site access when you request
				(e.g. username retrieval, password resets, etc.).
			</div>
		</div>
	</div>);
export default track({ page: "Unsubscribe" }, { dispatchOnMount: true })(Unsubscribe);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/Unsubscribe/Unsubscribe.tsx